let openMenu = document.querySelector(".nav-primary__toggle");
let mainMenu = document.querySelector(".nav-primary__links");
let menuIcon = openMenu.querySelector(".menu-icon");
let menuIconText = menuIcon.querySelector(".button-text");
let header = document.querySelector(".header");
let grid = document.querySelector(".grid");

function disableScroll() {
	const scrollY = (document.body.style.top = `-${window.scrollY}px`);
	document.body.style.position = "fixed";
	document.body.style.top = scrollY + "px";
	document.body.style.left = 0;
	document.body.style.right = 0;
}

function visibleScroll() {
	const scrollY = document.body.style.top;
	document.body.style.position = "";
	document.body.style.top = "";
	document.body.style.left = "";
	document.body.style.right = "";
	window.scrollTo(0, parseInt(scrollY || "0") * -1);
}

function menuOpen() {
	mainMenu.classList.add("open");
	openMenu.classList.add("open");
	grid.classList.add("open");
	header.classList.add("open");
	disableScroll();

	menuIconText.textContent = "Close";
	menuIcon.setAttribute("aria-label", "close menu");
}

function menuClose() {
	mainMenu.classList.remove("open");
	openMenu.classList.remove("open");
	grid.classList.remove("open");
	header.classList.remove("open");
	visibleScroll();

	menuIconText.textContent = "Menu";
	menuIcon.setAttribute("aria-label", "open menu");
}

openMenu.addEventListener("click", () => {
	if (openMenu.classList.contains("open")) {
		menuClose();
	} else {
		menuOpen();
	}
});

window.onload = () => {
	window.addEventListener("resize", () => {
		if (window.innerWidth > 1023 && openMenu.classList.contains("open")) {
			menuClose();
		}
	});
};



// WEBPACK FOOTER //
// ./scripts/modules/_mobile-menu.js